import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4df27a0c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "parent-div-profile-info"
};
const _hoisted_2 = {
  class: "settings-container"
};
const _hoisted_3 = {
  class: "settings-header"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "PPC Settings", -1));
const _hoisted_5 = {
  class: "settings-option"
};
const _hoisted_6 = {
  class: "option-info"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "header"
}, "Budget ending notifications"), /*#__PURE__*/_createElementVNode("span", {
  class: "body"
}, "Omny notify you when a budget is about to end without a new one in place.")], -1));
const _hoisted_8 = {
  class: "option-button"
};
const _hoisted_9 = {
  class: "settings-option"
};
const _hoisted_10 = {
  class: "option-info"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "header"
}, "Budget change notifications"), /*#__PURE__*/_createElementVNode("span", {
  class: "body"
}, "Omny notify you when a budget is updated.")], -1));
const _hoisted_12 = {
  class: "option-button"
};
const _hoisted_13 = {
  class: "settings-container",
  style: {
    "display": "none"
  }
};
const _hoisted_14 = {
  class: "settings-header"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "Some other module", -1));
const _hoisted_16 = {
  class: "settings-option"
};
const _hoisted_17 = {
  class: "option-info"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "header"
}, "Budget change notifications"), /*#__PURE__*/_createElementVNode("span", {
  class: "body"
}, "One or two line description to explain what each of these notifications mean and what would happen when they’re turned off. This description would be helpful here since these settings are out of the context of the module they affect.")], -1));
const _hoisted_19 = {
  class: "option-button"
};
const _hoisted_20 = {
  class: "settings-option"
};
const _hoisted_21 = {
  class: "option-info"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "header"
}, "Budget ending notifications"), /*#__PURE__*/_createElementVNode("span", {
  class: "body"
}, "One or two line description to explain what each of these notifications mean and what would happen when they’re turned off. This description would be helpful here since these settings are out of the context of the module they affect.")], -1));
const _hoisted_23 = {
  class: "option-button"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_switch = _resolveComponent("app-switch");
  const _component_app_card = _resolveComponent("app-card");
  return _openBlock(), _createBlock(_component_app_card, {
    loading: $data.dataLoading,
    title: "",
    scrollable: false
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_app_icon, {
      icon: "notification-setting",
      class: "setting-icon"
    }), _hoisted_4]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_app_icon, {
      icon: "notification-bell",
      class: "setting-icon"
    }), _hoisted_7]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_app_switch, {
      modelValue: $options.notification.should_receive_budget_end_notification,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.notification.should_receive_budget_end_notification = $event),
      noIcon: "",
      simple: "",
      onChange: $options.onChangeNotificationSetting
    }, null, 8, ["modelValue", "onChange"])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_app_icon, {
      icon: "notification-bell",
      class: "setting-icon"
    }), _hoisted_11]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_app_switch, {
      modelValue: $options.notification.should_receive_budget_change_notification,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $options.notification.should_receive_budget_change_notification = $event),
      noIcon: "",
      simple: "",
      onChange: $options.onChangeNotificationSetting
    }, null, 8, ["modelValue", "onChange"])])])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_app_icon, {
      icon: "notification-setting",
      class: "setting-icon"
    }), _hoisted_15]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_app_icon, {
      icon: "notification-bell",
      class: "setting-icon"
    }), _hoisted_18]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_app_switch, {
      noIcon: "",
      simple: ""
    })])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createVNode(_component_app_icon, {
      icon: "notification-bell",
      class: "setting-icon"
    }), _hoisted_22]), _createElementVNode("div", _hoisted_23, [_createVNode(_component_app_switch, {
      noIcon: "",
      simple: ""
    })])])])])]),
    _: 1
  }, 8, ["loading"]);
}